import { render } from "./ButtonsDefault.vue?vue&type=template&id=9aa0be20&scoped=true"
import script from "./ButtonsDefault.vue?vue&type=script&lang=js"
export * from "./ButtonsDefault.vue?vue&type=script&lang=js"

import "./ButtonsDefault.vue?vue&type=style&index=0&id=9aa0be20&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa0be20"]])

export default __exports__